import React, { PureComponent } from 'react';
import { connect } from "react-redux";
import Select from 'react-select';

import './styles.scss';
import { addAdminUsers, getListRoles, ACTIONS, updateAdminUsers } from './../../../../actions/admin-user';
import Loading from '../../../../components/loading';

const DropdownIndicator = () => {
	return <img src="/img/ic_arrow_down1.svg" alt="img"/>
};

class AdminUserAdd extends PureComponent {

	constructor(props) {
		super(props);
		this.state = {
			listRoles: [],
			id : '',
			showLoading : false,
			isAdd : true,
			email : '',
			name  : '',
			role_id : '',
			password : '',
			formErrors: { email: '', password: '' },
			emailValid: false,
			passwordValid :false,
			formValid: false,
		}
	}

	validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let emailValid = this.state.emailValid;
		// let passwordValid = this.state.passwordValid;
		let isEmpty;
        switch (fieldName) {
            case 'email':
				isEmpty = !value ? false : true
                emailValid = value.match(/^([a-zA-Z_0-9]|[ｧ-ﾝﾞﾟ]|[0-9\@\.\_\-])*$/i) && isEmpty;
                fieldValidationErrors.email = emailValid ? '' : 'is invalid';
				break;
			// case 'password':
			// 	if (this.state.isAdd) {
			// 		passwordValid = value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/i);
			// 	} else {
			// 		passwordValid = true;
			// 	}
			// 	fieldValidationErrors.password = passwordValid ? '' : 'is invalid';
			// 	break;
            default:
                break;
        }
        this.setState({
            formErrors: fieldValidationErrors,
			emailValid: emailValid,
			// passwordValid: passwordValid
        }, this.validateForm);
	}

	validateFieldPassword(fieldName, value) {
		let fieldValidationErrors = this.state.formErrors;
		let passwordValid = this.state.passwordValid;
		let isEmpty ;
		switch (fieldName) {
			case 'password':
				isEmpty = !value ? false : true
				passwordValid = value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/i) && isEmpty;
				fieldValidationErrors.password = passwordValid ? '' : 'is invalid';
				break;
            default:
                break;
        }
        this.setState({
            formErrors: fieldValidationErrors,
			passwordValid: passwordValid
        }, this.validateForm);
	}

	validateForm() {
        this.setState({ formValid: this.state.emailValid && this.state.passwordValid });
    }

	UNSAFE_componentWillMount() {
		this.props.getListRoles();
		const { detailUser, isAdd } = this.props;
		// console.log(this.state.isAdd);

		const params = {
			id : detailUser ? detailUser[0].id : '',
			email : detailUser ? detailUser[1].text : '',
			name : detailUser ? detailUser[0].text : '',
			role_id : detailUser ? detailUser[2].id : '',
			emailValid: !isAdd,
			passwordValid: !isAdd,
			formValid: !isAdd
		};
		this.setState(params);
	}

	componentDidMount() {
		this.commonHideComponent('add', 'modal-content');
	}

	commonHideComponent(p, c) {
        const wrapWorkspace = document.getElementById(p);
        const workspace = document.getElementById(c);
        if (wrapWorkspace) {

        let self = this;
        wrapWorkspace.addEventListener('click', function (event) {
            const isClickInside = workspace.contains(event.target);
            if (!isClickInside) {
                self.props.onClose();
            }
		});
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		this.setState({
			isAdd: nextProps.isAdd
		})

		if (nextProps && nextProps.response) {
			if (nextProps.type === ACTIONS.ADD_ADMIN_USERS_SUCCESS || nextProps.type === ACTIONS.UPDATE_ADMIN_USERS_SUCCESS) {
				this.setState({
					showLoading: false,
				});
				this.props.onCreate();

			} else if (nextProps.type === ACTIONS.GET_ROLES_SUCCESS) {
				// const obj = {
				// 	id : 0,
				// 	name : ''
				// };
				let arr = [ ...nextProps.response ];
				// arr.unshift(obj);
				// console.log(arr);

				const role_id = nextProps.response ? nextProps.response.slice(-1)[0].id : '';

				this.setState({
					showLoading: false,
					listRoles: arr,
					role_id : this.state.id ? this.state.role_id : role_id,
				});
			}
		}
	}

	handleChange(inputName, value) {
		this.setState({ [inputName]: value },
			() => {
				if (!this.state.isAdd && (inputName == 'password' && !value)) {
					this.setState({
						passwordValid: true
					}, () => {
						this.validateField(inputName, value);
					})

				} else {
					this.validateFieldPassword(inputName,value);
					this.validateField(inputName, value)
				}

			}
		);
	}

	onChange(text) {
		this.setState({
			"role_id": ''+text
		})
	}

	onClickAddUser() {
		// if (this.state.formValid) {
			this.setState({ showLoading : true })
			const { email, name, password, role_id } = this.state;
			const body = {
				email,
				name,
				password,
				role_id
			};
			if (this.state.isAdd) {
				this.props.addAdminUsers(body);
			} else {
				this.props.updateAdminUsers(body, this.state.id);
			}
		// }
	}

	render() {
		// eslint-disable-next-line react/prop-types
		const { onClose } = this.props;
		return (
			<div className="modal-custom" id="add">
				<div className="modal">
					<div className="modal-content" id="modal-content">
						<div className="modal-header">
							<span className="modal-title">{ this.state.isAdd ? 'スタッフ追加' : '設定'}</span>
						</div>
						<div className="modal-body">
							<form>
								<div className="form-group">
									<span className="label-text">ログインID</span>
									<input
										type="text"
										placeholder="ログインIDを入力してください"
										value={this.state.email}
										onChange={(event) => this.handleChange('email', event.target.value)}
										/>
								</div>
								<div className="form-group">
									<span className="label-text">名前</span>
									<input type="text" placeholder="名前を入力してください"
										value={this.state.name}
										onChange={(event) => this.handleChange('name', event.target.value)} />
								</div>
								<div className="form-group">
									<span className="label-text">パスワード</span>
									<input
										type="password"
										placeholder="パスワードを入力してください"
										autocomplete="new-password"
										value={this.state.password}
										onChange={(event) => this.handleChange('password', event.target.value)}
										/>
								</div>
								<div className="form-group">
									<span className="label-text">ロール</span>
									<select onChange={ev => this.onChange(ev.target.value)}  value={this.state.role_id} className="form-control select-custom">
										{this.state.listRoles.map((items, index) => {
											// if (this.state.role_id === items.id) {
												return(<option key={index.toString()} value={ items.id }  >{  items.name}</option>)
											// } else {
												// return(<option key={index.toString()} value={ items.id } className='tick-before' >{ items.name}</option>)
											// }

										})}
										<option value=''>ロールなし</option>
									</select>
								</div>
							</form>
						</div>
						<div className="modal-footer">
							<button type="button" className="" onClick={onClose}>キャンセル</button>
							<button
								disabled={!this.state.formValid}
								type="button"
								className=""
								onClick={() => this.onClickAddUser()}>
							{ this.props.textEdit || '追加' }</button>
						</div>
					</div>
				</div>

				<Loading show={ this.state.showLoading } />
			</div>
		);
	}
}

const mapStateToProps = ({ adminUsers }) => {
	return {
		header: adminUsers.header,
		dataAdminUser: adminUsers.dataAdminUser,
		response: adminUsers.response,
		type: adminUsers.type,
		message  :adminUsers.message
	}
}

const mapDispatchToProps = dispatch => {
	return {
		addAdminUsers: (data) => {
			dispatch(addAdminUsers(data));
		},
		getListRoles: (data) => {
			dispatch(getListRoles(data));
		},
		updateAdminUsers: (data, id) => {
            dispatch(updateAdminUsers(data, id));
        }
	}
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure : false })(AdminUserAdd);